/*
    Take a slug, and add it to the end of
    our current baseURL!
*/
export function buildListingLink(slug) {

    let baseURL = window.location.pathname;
    baseURL += baseURL.endsWith('/') ? '' : '/';
    
    const url = baseURL + 'listing/' + slug;

    return url;
};
